export const storeName = 'preferences';

export default {
  language: 'eng',
  timeFormat: '24h',
  oddFormat: 'decimal',
  timeZone: '',
  sound: 0.75,
};
